<template>
    <tbody :class="`block lg:table-row-group  ${customClass}`">
        <slot></slot>
    </tbody>
</template>
<script>
export default{
    name: 'TableBody',
    props: {
        customClass: {
            type: String,
            default: ''
        }
    }
}
</script>
